// @flow
import React from 'react';
import {ApolloProvider} from 'react-apollo';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader/root';
import {HelmetProvider} from 'react-helmet-async';

import {ExperimentProvider} from '@homeaway/react-experiment';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';

import IntlWrapper from '../IntlWrapper/IntlWrapper';

import type {Store} from 'redux';
import type {ApolloClient} from 'apollo-client';
import type {State as AbacusState} from '../../reducers/abacus';
import type {Node} from 'react';

export type Props = {
    abacus: AbacusState,
    client: ApolloClient<*>,
    store: Store<*, *>,
    helmetContext: {},
    children: Node,
    siteContext: {}
};

function Root({
    helmetContext,
    client,
    store,
    abacus,
    children,
    siteContext
}: Props) {
    return (
        <HelmetProvider context={helmetContext}>
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <ExperimentProvider abacus={abacus}>
                        <LocalizationContextProvider siteContext={siteContext}>
                            <IntlWrapper>{children}</IntlWrapper>
                        </LocalizationContextProvider>
                    </ExperimentProvider>
                </Provider>
            </ApolloProvider>
        </HelmetProvider>
    );
}

export default hot(Root);
